// API Configuration
// Detects environment at runtime and uses appropriate API base URL

// Get the API base URL based on the current environment
function getApiBase() {
  // Check if we're in a browser environment
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  
  const hostname = window.location.hostname;
  
  // Production domains - use relative URLs
  if (hostname.includes('theramirezlegalgroup.com') || 
      hostname.includes('emergent.host')) {
    return '';
  }
  
  // Development/Preview - use the backend URL from env
  return process.env.REACT_APP_BACKEND_URL || '';
}

export const API_BASE = getApiBase();
export const API = `${API_BASE}/api`;

export default API;
